import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Accordion, AccordionItem, Collapse } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import CountUp from "react-countup";
import SimpleBar from "simplebar-react";
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import CurrencyInput from "react-currency-input-field";
import ModalImage from "react-modal-image";
import { api } from "../../../config";

// Formik
import { useSelector, useDispatch } from "react-redux";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { addNewAccTrans as onAddNewAccTrans, getAccTrans, updateAccTrans as onUpdateAccTrans, getAccTransLoading } from "../../../store/accTrans/action";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Purchase = () => {
  const printRef = useRef(null);
  const expanseDataRef = useRef([]);
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, companies, vendors, vendorLoading, branches, branchLoading, civilBudgets, civilBudgetLoading, departments, departmentLoading, accTranss, accTransAdded, isAccTransCreated, isAccTransSuccess, accTransloading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    companies: state.Company.companies,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    accTranss: state.AccTrans.accTranss,
    accTransAdded: state.AccTrans.accTransAdded,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    accTransloading: state.AccTrans.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);
  const [info, setInfo] = useState([]);
  const [expense, setExpense] = useState([]);
  const [label, setLabel] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchBudget, setSearchBudget] = useState("");
  const [searchDepartment, setSearchDepartment] = useState(null);
  const [departmentSelect, setDepartmentSelect] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetTypeList, setCivilBudgetTypeList] = useState([]);

  const [printMaterialDoc, setPrintMaterialDoc] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const scrollRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);

    const rect = scrollRef.current.getBoundingClientRect();

    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);

    setScrollLeft(scrollRef.current.scrollLeft);
    setScrollTop(scrollRef.current.scrollTop);
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();

    const rect = scrollRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const walkX = (x - startX) * 1.5; // speed horizontal
    const walkY = (y - startY) * 1.5; // speed vertical

    scrollRef.current.scrollLeft = scrollLeft - walkX;
    scrollRef.current.scrollTop = scrollTop - walkY;
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "supplier",
        label: "Kontak / Pelanggan",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "No Invoice",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "left_amount",
        label: "Menunggu Bayar",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "supplier");
          doc.data.push(label);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transaction_reff");
          doc.data.push(data?.transaction_reff);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "dueat");
          doc.data.push(data?.dueat ? handleValidDate(data?.dueat) : handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "total_amount");
          doc.data.push(data?.total_amount);

          doc = dataDoc.find((d) => d.id === "paid_amount");
          doc.data.push(data?.paid_amount);

          doc = dataDoc.find((d) => d.id === "left_amount");
          doc.data.push(data?.total);

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintMaterialDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "supplier",
        label: "Kontak / Pelanggan",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis Hutang",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total Hutang",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "total",
        label: "Sisa Hutang",
        isSelected: true,
        data: [],
      },
      {
        id: "range1",
        label: "1-30 Hari",
        isSelected: true,
        data: [],
      },
      {
        id: "range2",
        label: "30-60 Hari",
        isSelected: true,
        data: [],
      },
      {
        id: "range3",
        label: "60-90 Hari",
        isSelected: true,
        data: [],
      },
      {
        id: "range4",
        label: "90-135 Hari",
        isSelected: true,
        data: [],
      },
      {
        id: "range5",
        label: "> 135 Hari",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((purchase) => {
        if (purchase.isChecked) {
          Object.entries(purchase).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "range1" || doc.id === "range2" || doc.id === "range3" || doc.id === "range4" || doc.id === "range5") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else {
                doc.data.push(value);
              }
            }
          });
        }
      });
    }
    setPrintDoc(dataDoc);
  }, [purchaseList]);

  const handleGetPayable = (id, branchId) => {
    dispatch(getAccTrans({ receivable: true, companyId: id, branchId: branchId, date: "all" }));
    setBranchIdSelected(branchId);
    handleGetCivilBudget(id, branchId);
    handleGetDepartement(id);
    handleGetVendor(id);
  };

  const handleGetVendor = (companyId) => {
    dispatch(resetVendorState());
    dispatch(getVendor({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [{ label: "SEMUA DEPT.", value: "" }];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilTypeData = [{ label: "SEMUA ANGGARAN", value: "all" }];
      var opt = [];
      var optType = [];
      civilBudgets
        .filter((f) => f.type === "BANGUNAN" || f.type === "INFRASTRUKTUR" || f.type === "PEKERJAAN TAMBAH 1" || f.type === "PEKERJAAN TAMBAH 2" || f.type === "PEKERJAAN TAMBAH 3" || f.type === "PEKERJAAN TAMBAH 4" || f.type === "PEKERJAAN TAMBAH 5" || f.type === "PEKERJAAN TAMBAH 6" || f.type === "PEKERJAAN TAMBAH 7" || f.type === "PEKERJAAN TAMBAH 8" || f.type === "LISTRIK JARINGAN")
        .forEach((it, idx) => {
          const type = it.type ? it.type : "";
          const typeName = it.name ? it.name : "";
          if (branchIdSelected === it.branchId) {
            const budgetId = it.id ? it.id : "";
            it.cvl_detail.forEach((item, key) => {
              const name = item?.cvld_account?.name;
              const id = item?.cvld_account?.id;
              opt.push({ label: type + " - " + name, cvl_account: name, value: budgetId, type: type, civilBudgetId: budgetId, civilBudgetDetailId: item.id, civilAccountId: id, material: item.cvld_material });
            });
          }
          optType.push({ label: typeName, value: it.id });
        });
      var option = { options: opt };
      var option_type = { options: optType };
      civilBudgetData.push(option);
      civilTypeData.push(option_type);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetTypeList(civilTypeData);
    } else {
      setCivilBudgetTypeList([]);
      setCivilBudgetList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
    let filteredAccTrans = [];
    if (tab === "all") {
      for (const t of accTranss || []) filteredAccTrans.push(t);
    } else if (tab === "other") {
      for (const t of accTranss || [])
        for (const trans of t.at_payment_detail) {
          if (trans?.at_payment?.at_pm?.sales === "thp3_amount" || trans?.at_payment?.at_pm?.sales === "thp4_amount") filteredAccTrans.push(t);
        }
    } else {
      for (const t of accTranss || [])
        for (const trans of t.at_payment_detail) {
          if (trans?.at_payment?.at_pm?.sales === activeTab) filteredAccTrans.push(t);
        }
    }

    let arr = [];
    for (const data of filteredAccTrans.filter((f) => f.statusId === 2 || f.statusId === 3)) {
      let supplier = arr.find((d) => d.supplier === data?.at_user?.name && d.type === "Keuangan");

      const a = moment.utc(data.transactionat, "YYYY/MM/DD HH:mm:ss").local();
      const b = moment.utc().local();
      const total_amount = parseFloat(data.amount || 0);
      const paid_amount = (data.at_payment_detail || [])
        .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
        .map((el) => parseFloat(el.amount || 0))
        .reduce((prev, curr) => prev + curr, 0);
      const total = total_amount - paid_amount;

      if (supplier) {
        let ttl = supplier.total + total;
        let ttl_amount = supplier.total_amount + total_amount;
        let ttl_paid_amount = supplier.paid_amount + paid_amount;
        supplier.total = ttl;
        supplier.total_amount = ttl_amount;
        supplier.paid_amount = ttl_paid_amount;
        supplier.realization = [...supplier.realization, ...(data.at_payment_detail ? data.at_payment_detail : [])];
        supplier.realization = [...supplier.realization, data];
        supplier.detail.push({
          id: data?.id,
          departmentId: data?.departmentId,
          rab: data.civilBudgetId ? data?.at_budget?.type : "",
          type: "Keuangan",
          branch: data?.at_branch?.branch_code,
          civilContractId: null,
          purchaseId: null,
          userId: data?.at_user?.id || null,
          vendorId: null,
          transaction_no: data?.transaction_no,
          transactionat: data?.transactionat,
          dueat: data?.transactionat,
          transaction_reff: data?.transaction_reff,
          description: data?.description,
          name: data?.at_user?.name,
          supplier: data?.at_user?.name,
          file: data?.at_file,
          total: total,
          total_amount: total_amount,
          paid_amount: paid_amount,
        });
      } else {
        arr.push({
          id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
          type: "Keuangan",
          branch: data?.at_branch?.branch_code,
          name: data?.at_user?.name,
          supplier: data?.at_user?.name,
          total_amount: total_amount,
          paid_amount: paid_amount,
          total: total,
          realization: [data, ...(data.at_payment_detail ? data.at_payment_detail : [])],
          detail: [
            {
              id: data?.id,
              departmentId: data?.departmentId,
              rab: data.civilBudgetId ? data?.at_budget?.type : "",
              type: "Keuangan",
              branch: data?.at_branch?.branch_code,
              civilContractId: null,
              purchaseId: null,
              userId: data?.at_user?.id || null,
              vendorId: null,
              transaction_no: data?.transaction_no,
              transactionat: data?.transactionat,
              dueat: data?.transactionat,
              transaction_reff: data?.transaction_reff,
              description: data?.description,
              name: data?.at_user?.name,
              supplier: data?.at_user?.name,
              file: data?.at_file,
              total: total,
              total_amount: total_amount,
              paid_amount: paid_amount,
            },
          ],
        });
      }
    }

    setPurchaseList(arr.map((el) => ({ ...el, isChecked: false })));
    setInfo(arr[arr.length - 1]);
  };

  useEffect(() => {
    let filteredAccTrans = searchDepartment?.value ? accTranss.filter((f) => f?.departmentId === searchDepartment?.value) : accTranss;
    if (activeTab !== "all") {
      if (activeTab === "other") {
        let transList = [];
        for (const trans of accTranss || []) if (trans.at_pm && (trans.at_pm.sales === "thp3_amount" || trans.at_pm.sales === "thp4_amount")) transList.push(trans);
        filteredAccTrans = transList;
      } else {
        let transList = [];
        for (const trans of accTranss || []) if (trans.at_pm && trans.at_pm.sales === activeTab) transList.push(trans);
        filteredAccTrans = transList;
      }
    }

    let arr = [];
    for (const data of filteredAccTrans.filter((f) => f.statusId === 2 || f.statusId === 3)) {
      let supplier = arr.find((d) => d.supplier === data?.at_user?.name && d.type === "Keuangan");

      const a = moment.utc(data.transactionat, "YYYY/MM/DD HH:mm:ss").local();
      const b = moment.utc().local();
      const total_amount = parseFloat(data.amount || 0);
      const paid_amount = (data.at_payment_detail || [])
        .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
        .map((el) => parseFloat(el.amount || 0))
        .reduce((prev, curr) => prev + curr, 0);
      const total = total_amount - paid_amount;

      if (supplier) {
        let ttl = supplier.total + total;
        let ttl_amount = supplier.total_amount + total_amount;
        let ttl_paid_amount = supplier.paid_amount + paid_amount;
        supplier.total = ttl;
        supplier.total_amount = ttl_amount;
        supplier.paid_amount = ttl_paid_amount;
        supplier.realization = [...supplier.realization, ...(data.at_payment_detail ? data.at_payment_detail : [])];
        supplier.realization = [...supplier.realization, data];
        supplier.detail.push({
          id: data?.id,
          departmentId: data?.departmentId,
          rab: data.civilBudgetId ? data?.at_budget?.type : "",
          type: "Keuangan",
          branch: data?.at_branch?.branch_code,
          civilContractId: null,
          purchaseId: null,
          userId: data?.at_user?.id || null,
          vendorId: null,
          transaction_no: data?.transaction_no,
          transactionat: data?.transactionat,
          dueat: data?.transactionat,
          transaction_reff: data?.transaction_reff,
          description: data?.description,
          name: data?.at_user?.name,
          supplier: data?.at_user?.name,
          file: data?.at_file,
          total: total,
          total_amount: total_amount,
          paid_amount: paid_amount,
        });
      } else {
        arr.push({
          id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
          type: "Keuangan",
          branch: data?.at_branch?.branch_code,
          name: data?.at_user?.name,
          supplier: data?.at_user?.name,
          total_amount: total_amount,
          paid_amount: paid_amount,
          total: total,
          realization: [data, ...(data.at_payment_detail ? data.at_payment_detail : [])],
          detail: [
            {
              id: data?.id,
              departmentId: data?.departmentId,
              rab: data.civilBudgetId ? data?.at_budget?.type : "",
              type: "Keuangan",
              branch: data?.at_branch?.branch_code,
              civilContractId: null,
              purchaseId: null,
              userId: data?.at_user?.id || null,
              vendorId: null,
              transaction_no: data?.transaction_no,
              transactionat: data?.transactionat,
              dueat: data?.transactionat,
              transaction_reff: data?.transaction_reff,
              description: data?.description,
              name: data?.at_user?.name,
              supplier: data?.at_user?.name,
              file: data?.at_file,
              total: total,
              total_amount: total_amount,
              paid_amount: paid_amount,
            },
          ],
        });
      }
    }

    setPurchaseList(arr.map((el) => ({ ...el, isChecked: false })));
    setInfo(arr[arr.length - 1]);
  }, [accTranss, searchDepartment]);

  const toggleCount = (type) => {
    let filteredAccTranss = [];

    if (type === "other") {
      for (const t of accTranss || [])
        for (const trans of t.at_payment_detail) {
          if (trans?.at_payment?.at_pm?.sales === "thp3_amount" || trans?.at_payment?.at_pm?.sales === "thp4_amount") filteredAccTranss.push(t);
        }
    } else {
      for (const t of accTranss || [])
        for (const trans of t.at_payment_detail) {
          if (trans?.at_payment?.at_pm?.sales === activeTab) filteredAccTranss.push(t);
        }
    }
    return filteredAccTranss.length;
  };

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {}, []);

  const handleBeforePrint = useCallback(() => {}, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPurchaseList(updatedData);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: "Kontak / Pelanggan",
        accessor: "name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-primary fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.detail;
                setLabel(data.name || "NO NAME");
                setExpense(data.detail);
                setModalDetail(true);
              }}
            >
              {data.name || "NO NAME"}
            </div>
          );
        },
      },
      {
        id: "MenungguInv",
        Header: <div className="pe-3">Transaksi</div>,
        accessor: "invoice_non_amount",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-primary fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.detail;
                setLabel(data.supplier);
                setExpense(data.detail);
                setModalDetail(true);
              }}
            >
              {data?.detail?.length} Transaksi
            </div>
          );
        },
      },
      {
        id: "Total",
        Header: "Total Piutang",
        accessor: (data) => data.realization.filter((el) => el.type === "RECEIVABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-primary fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Receivable",
        Header: "Pencairan Piutang",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "receivable" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Sbum",
        Header: "Pencairan SBUM",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "sbum_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}>
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Sertifikat",
        Header: "Pencairan Sertifikat",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "cert_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Pbg",
        Header: "Pencairan PBG",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "imb_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Listrik",
        Header: "Pencairan Listrik",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "electricity_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Jkk",
        Header: "Pencairan JKK",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "jkk_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Bestek",
        Header: "Pencairan BESTEK",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "bestek_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Air",
        Header: "Pencairan Air",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "water_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Ppjb",
        Header: "Pencairan PPJB",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && el?.at_payment?.at_pm?.sales === "ppjb_amount" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
      {
        id: "Other",
        Header: "Pencairan Lainnya",
        accessor: (data) => data.realization.filter((el) => el.type === "CASH IN" && (el?.at_payment?.at_pm?.sales === "thp3_amount" || el?.at_payment?.at_pm?.sales === "thp4_amount") && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-success fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },

      {
        id: "Sisa",
        Header: "Sisa Piutang",
        accessor: (data) => data.realization.filter((el) => el.type === "RECEIVABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) - data.realization.filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div
              className="cursor-pointer text-danger fw-semibold"
              onClick={() => {
                expanseDataRef.current = data.realization;
                setInfo(data);
                setExpense(data.realization || []);
                toggle();
              }}
            >
              {currencyFormat(cellProps.value)}
            </div>
          );
        },
      },
    ], [purchaseList, activeTab, isCheckAll],
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Keterangan", "UmurHutang", "UangMuka"],
        pageIndex: pageIdx,
        pageSize: 500,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    var status = statusPurchase.value ? statusPurchase.value : "";
    if (filterDate) {
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
        const param = {
          title: searchValue,
          startat: startat,
          endat: endat,
          status: status,
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          receivable: true,
        };
        dispatch(getAccTrans(param));
      } else {
        const param = {
          title: searchValue,
          status: status,
          date: "all",
          departmentId: searchDepartment?.value ?? "",
          branchId: branchSelected?.value ?? "",
          companyId: companySelected?.value ?? "",
          typeId: 1,
          receivable: true,
        };
        dispatch(getAccTrans(param));
      }
    } else {
      const param = {
        title: searchValue,
        status: status,
        date: "all",
        departmentId: searchDepartment?.value ?? "",
        branchId: branchSelected?.value ?? "",
        companyId: companySelected?.value ?? "",
        typeId: 1,
        expense: true,
      };
      dispatch(getAccTrans(param));
    }
  }

  function handleResetFilter() {
    setSearchBudget("");
    setFilterDate(null);
    setStatusPurchase([]);
    setSearchDepartment("");
    setSearchValue("");
    setInfo({});
    handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
  }

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el.transaction_reff ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          ((el.paid_amount ?? "").toString() ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          ((el.total ?? "").toString() ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          ((el.total_amount ?? "").toString() ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.supplier ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.branch ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      company: companySelected,
      client: clientSelected,
      branch: branchSelected,
      transactionat: moment().format("YYYY/MM/DD"),
      departmentId: "",
      description: "",
      paymentMethod: "",
      type: "CASH OUT",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Silahkan isi Jumlah Transaksi"),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Proyek / Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAccTransLoading());
      if ((expense || []).filter((item) => item.isChecked).length) {
        let addSubmit = {
          statusId: 1,
          userId: null,
          type: values.type,
          transactionat: values.transactionat,
          paymentMethodId: null,
          description: values.description,
          clientId: values.client.value,
          budgetId: null,
          approval: true,
          tagId: null,
          companyId: values.company.value,
          departmentId: (expense || []).filter((item) => item.isChecked).length && (expense || []).filter((item) => item.isChecked)[0].departmentId,
          branchId: values.branch.value,
          salesId: null,
          purchaseId: null,
          legalId: null,
          civilContractId: null,
          civilAccountId: null,
          civilBudgetId: null,
          civilBudgetDetailId: null,
          amount: values.amount,
          at_detail: JSON.stringify([]),
          at_rls: JSON.stringify((expense || []).filter((item) => item.isChecked)),
        };
        dispatch(onAddNewAccTrans(addSubmit));
      }
      validationAccPayment.resetForm();
      setModalAccPayment(false);
      setModalDetail(false);
      handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
    },
  });

  useEffect(() => {
    if (branchSelected && companySelected) {
      setInfo({});
      handleGetPayable(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  document.title = "Piutang | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Piutang" loading={accTransloading}>
          <div className="flex-shrink-0">
            <ExportDoc data={printDoc} />
            {/* <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>  */}
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={12} className={userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").indexOf("viewAccTransaction") > 0) ? "d-none" : "d-none"}>
            <div className="hstack gap-3">
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "all" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("all");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "all" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">SEMUA </div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "sbum_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("sbum_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "sbum" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("sbum_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">SBUM</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "cert_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("cert_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "cert_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("cert_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">SERTIFIKAT</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "imb_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("imb_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "imb_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("imb_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">PBG</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "electricity_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("electricity_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "electricity_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("electricity_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">LISTRIK</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "jkk_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("jkk_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "jkk_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("jkk_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">JKK</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "bestek_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("bestek_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "bestek_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("bestek_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">BESTEK</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "water_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("water_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "water_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("water_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">AIR</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "ppjb_amount" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("ppjb_amount");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "ppjb_amount" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("ppjb_amount")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">PPJB</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeTab === "other" ? { borderBottom: "3px solid #FFCC00", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 10 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleTab("other");
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeTab === "other" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{toggleCount("other")}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">LAINNYA</div>
                </div>
              </div>
            </div>
          </Col>

          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div
                    className="table-responsive table-card table-container-sticky mb-1 table-scroll"
                    ref={scrollRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    // style={{ cursor: isDown ? "grabbing" : "grab", userSelect: isDown ? "none" : "auto" }}
                    style={{
                      overflow: "auto",
                      maxHeight: "calc(100vh - 340px)",
                      cursor: isDown ? "grabbing" : "grab",
                      //userSelect: isDown ? "none" : "auto",
                    }}
                  >
                    <Table hover {...getTableProps()} className="align-middle table-fixed-header table-nowrap">
                      <thead>
                        {headerGroups.map((headerGroup, index) => (
                          <tr className="bg-soft-info" {...headerGroup.getHeaderGroupProps()} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                        <tr className="table-light">
                          <th></th>
                          <th colSpan={2}>
                            Total <em className="fs-11 text-muted fw-normal"></em>
                          </th>
                          <th className="text-primary fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Total || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Receivable || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Sbum || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Sertifikat || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Pbg || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Listrik || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Jkk || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Bestek || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Air || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Ppbj || 0)), 0))}</th>
                          <th className="text-info fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Other || 0)), 0))}</th>
                          <th className="text-danger fs-14">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.Sisa || 0)), 0))}</th>
                        </tr>
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    DETAIL TRANSAKSI {label}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody className="pb-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-grow-1">
                          <input className="search-box form-control" style={{ maxWidth: "320px" }} placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                        <div className="flex-shrink-0">
                          <ExportDoc data={printMaterialDoc} />
                        </div>
                      </div>
                      <div>
                        <SimpleBar style={{ height: "520px" }}>
                          <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                            <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                              <tr className="bg-soft-info">
                                <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => {
                                        return {
                                          ...item,
                                          isChecked: !allChecked,
                                        };
                                      });
                                      setExpense(updatedData);
                                    }}
                                  />
                                </td>
                                <td className="text-start">Kontak / Pelanggan</td>
                                <td style={{ width: "40px" }}></td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tanggal
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Total
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Terbayar
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Sisa
                                </td>
                                <td className="text-center">Keterangan</td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || [])
                                .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
                                .map((o, i) => {
                                  return (
                                    <Fragment key={i}>
                                      <tr className="product bg-light">
                                        <td className="product-id">
                                          <input
                                            type="checkbox"
                                            className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                            checked={o.isChecked}
                                            onChange={() => {
                                              const updatedData = expense.map((d) => {
                                                return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                              });

                                              setExpense(updatedData);
                                            }}
                                          />{" "}
                                          {i + 1}
                                        </td>
                                        <td className="text-start fw-semibold">{o.name || "NO NAME"}</td>
                                        <td className="text-center fw-semibold">{o.branch}</td>
                                        <td className="text-center">{o.transaction_no}</td>
                                        <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                        <td className={"text-center fw-semibold"}>{currencyFormat(parseFloat(o.total_amount ?? 0))}</td>
                                        <td className={"text-center text-success fw-semibold"}>{currencyFormat(parseFloat(o.paid_amount ?? 0))}</td>
                                        <td className={parseFloat(o.total ?? 0) - parseFloat(o.paid_amount ?? 0) > 0 ? "text-center text-danger fw-semibold" : "text-center fw-semibold"}>{parseFloat(o.total ?? 0) - parseFloat(o.paid_amount ?? 0) > 0 ? currencyFormat(parseFloat(o.total ?? 0) - parseFloat(o.paid_amount ?? 0)) : "0"}</td>
                                        <td className="text-start">{o.description}</td>
                                      </tr>
                                      {(o.file || []).length > 0 && (
                                        <tr>
                                          <td></td>
                                          <td colSpan={10} className="pe-0">
                                            <Accordion className="p-0 w-100 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                                              {(o.file || []).length > 0 && (
                                                <AccordionItem className="border-0">
                                                  <div
                                                    className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i + 10000 ? false : true })}
                                                    onClick={() => {
                                                      toggleActiveAccordion(i + 10000);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                  >
                                                    <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                                      Bukti Transaksi
                                                    </div>
                                                  </div>
                                                  <Collapse isOpen={activeAccordion === i + 10000 ? true : false} className="accordion-collapse bg-light border-0">
                                                    <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                                      {(o.file || []).map((f, ii) => {
                                                        let type;
                                                        return (
                                                          <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                              <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                                            ) : (
                                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                              </Link>
                                                            )}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </Collapse>
                                                </AccordionItem>
                                              )}
                                            </Accordion>
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>
                                  );
                                })}
                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="11" className="p-3 text-center">
                                    Belum ada data
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {info?.material_name ?? ""}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody>
                      <div>
                        <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                          <div className="col-sm-10">
                            <Row className="m-0 p-0 ">
                              <div className="fw-semibold  text-start">
                                <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                              </div>
                            </Row>
                          </div>
                          <div className="col-sm-2 text-end">
                            <ExportDoc data={printDetailDoc} />
                          </div>
                        </Row>
                        <SimpleBar style={{ height: "450px" }}>
                          <Table className="table-border text-center table-hover">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => ({
                                        ...item,
                                        isChecked: !allChecked,
                                      }));
                                      setExpense(updatedData);
                                    }}
                                  />
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center" style={{ width: "80px" }}>
                                  Tanggal
                                </td>
                                <td className="text-center" style={{ width: "80px" }}>
                                  Jenis
                                </td>
                                <td className="text-right" style={{ width: "170px" }}>
                                  Tag
                                </td>
                                <td className="text-right" style={{ width: "170px" }}>
                                  Jumlah
                                </td>
                                <td className="text-center" style={{ width: "200px" }}>
                                  Keterangan
                                </td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || []).map((o, i) => {
                                let type;
                                switch (o.type) {
                                  case "CASH IN":
                                    type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                                    break;
                                  case "RECEIVABLE":
                                    type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                                    break;
                                  case "PAYABLE":
                                    type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                                    break;
                                  case "CASH OUT":
                                    type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                                    break;
                                  default:
                                    type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                                    break;
                                }
                                return (
                                  // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                                  <tr key={i}>
                                    <td style={{ verticalAlign: "middle", width: "30px" }}>
                                      <div className="hstack gap-2 mt-4 mt-sm-0">
                                        <input
                                          type="checkbox"
                                          className="checkboxDetail me-2 form-check-input"
                                          checked={o.isChecked}
                                          onChange={() => {
                                            const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                            setExpense(updatedData);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {o.transaction_no}
                                      {o.statusId === 4 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                        </p>
                                      )}
                                      {o.statusId === 3 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                        </p>
                                      )}
                                      {o.statusId === 2 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                        </p>
                                      )}
                                      {o.statusId === 1 && (
                                        <p className="mb-1">
                                          <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                        </p>
                                      )}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {handleValidDate(o.transactionat)}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {type}
                                    </td>
                                    <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                      {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                      {currencyFormat(o.amount)}
                                    </td>
                                    <td className="text-left" style={{ verticalAlign: "middle" }}>
                                      {o.description}
                                    </td>
                                  </tr>
                                );
                              })}

                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="7" className="p-3 text-center">
                                    Belum ada realisasi
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                        <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                          <div className="col-sm-6 fs-12 text-start">
                            PIUTANG:
                            <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                              {currencyFormat(
                                (expense || [])
                                  .filter((el) => el.type === "RECEIVABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                                  .map((el) => parseFloat(el.amount || 0))
                                  .reduce((prev, curr) => prev + curr, 0),
                              )}
                            </span>
                          </div>
                          <div className="col-sm-6 fs-12 text-end">
                            PENCAIRAN KAS / BANK :
                            <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                              {currencyFormat(
                                (expense || [])
                                  .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                                  .map((el) => parseFloat(el.amount || 0))
                                  .reduce((prev, curr) => prev + curr, 0),
                              )}
                            </span>
                          </div>
                        </Row>
                      </div>
                    </CardBody>
                  </ModalBody>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    PENGAJUAN PEMBAYARAN HUTANG
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PENGAJUAN PEMBAYARAN</span>
                            {accTransloading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Purchase;
